import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { RecaptchaModule } from 'ng-recaptcha';
import { HttpClientModule } from '@angular/common/http';
import { ContactFormService } from './main/services/contact-form.service';
import { SaasMainModule } from './main/pages/index/index.module';
import { GoogleAnalyticsService } from './main/services/google-analytics.service';
import { LIGHTBOX_CONFIG, LightboxConfig } from 'ng-gallery/lightbox';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RecaptchaModule,
    HttpClientModule,
    SaasMainModule,
  ],
  providers: [
    ContactFormService,
    GoogleAnalyticsService,
    {
      provide: LIGHTBOX_CONFIG,
      useValue: {
        keyboardShortcuts: false,
        exitAnimationTime: 1000
      } as LightboxConfig
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
